export class DeliveryOnlyState {
  invoiceKeys: string[] = []; 
  promisedDate: string = "";
  orderId: string = "";
  email: string = "";
}